// extracted by mini-css-extract-plugin
module.exports = {"digit":"Digit_digit__7YmcP","digitContent":"Digit_digitContent__Do7RV"};